import RecallPageContainer from './RecallPageContainer';

export default RecallPageContainer;



// WEBPACK FOOTER //
// ./src/components/pages/RecallPage/index.js